import { createGlobalStyle } from "styled-components";
import { device } from "../components/Layout/mediaQuery";

export const GlobalStyle = createGlobalStyle`
html {
  font-size: 62.5%;
}
*{
  box-sizing: border-box;
}

body {
    margin: 0;
    font: 300 11px/1.4 "Open Sans", "sans-serif";
    color: ${(props) => props.theme.colorsPalette.white};
    background: ${(props) => props.theme.colors.bgColor};

    overflow-y: hidden;
    @media ${device.landscapeMobile} {
      overflow-y:auto;
    }

   
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;


  
  }
  p{
    line-height: 1.7;

    @media ${device.mobile}{
      font-size:12px;
    }
  }

  `;
